import { Events } from "./InputUtils";

/**
 * Holds mouse state data.
 */
export class MouseManager {
    private static _mouseDown: boolean = false;
    private _interactionManager: PIXI.interaction.InteractionManager;
    constructor(pInteractionManager: PIXI.interaction.InteractionManager) {
        this._interactionManager = pInteractionManager;

        this._interactionManager.addListener(Events.MOUSE_DOWN, this.onMouseDown, this);
        this._interactionManager.addListener(Events.MOUSE_UP, this.onMouseUp, this);
    }

    /**
     * Is the mouse currently down?
     */
    public static get mouseDown(): boolean {
        return MouseManager._mouseDown;
    }

    /**
     * Sets the mouse down flag to true.
     */
    private onMouseDown(): void {
        MouseManager._mouseDown = true;
    }

    /**
     * Sets the mouse down flag to false.
     */
    private onMouseUp(): void {
        MouseManager._mouseDown = false;
    }
}
